import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TramiteDimarDto } from '../dto/tramites/tramite-dimar.dto';

@Injectable({
  providedIn: 'root',
})
export class TramiteDimarService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/dimar/tramite/registrar-tramite';

  constructor(private http: HttpClient) {}

  postCrearTramiteDimar(data: FormData): Observable<any> {
    return this.http.post<TramiteDimarDto>(
      `${this.apiUrl}${this.baseUrl}`,
      data
    );
  }

  getramiteDimarByID(idTramiteDimar: number): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiUrl}/dimar/tramite/${idTramiteDimar}`
    );
  }
}
